import Home from "../Home";
import About from "../About";
import Download from "../Download";
import Marketplace from "../Marketplace";
import Event from "../Event";
import Notice from "../Support/Notice";
import Faq from "../Support/Faq";
import Qna from "../Support/Qna";
import Tos from "../Tos";
import Privacy from "../Privacy";
import NotFound from "../NotFound";
import { Navigate } from "react-router-dom";

let sm = [
    { breadcrumb: "홈", path: "/", element: <Home /> },
    { breadcrumb: "소개", name: "소개", navigation: true, path: "/about", element: <About />},
    { breadcrumb: "다운로드", name: "다운로드", navigation: true, path: "/download", element: <Download /> },
    { breadcrumb: "장터", name: "장터", navigation: true, path: "/marketplace", element: <Marketplace /> },
    { breadcrumb: "이벤트", name: "이벤트", navigation: true, path: "/event", element: <Event /> },
    {
        breadcrumb: "고객지원", name: "고객지원", navigation: true, path: "support",
        children: [
            { breadcrumb: "공지사항", name: "공지사항", navigation: true, path: "notice", element: <Notice /> },
            { breadcrumb: "FAQ", name: "FAQ", navigation: true, path: "faq", element: <Faq /> },
            { breadcrumb: "1:1 문의", name: "1:1 문의", navigation: true, path: "qna", element: <Qna /> },
            { breadcrumb: "고객지원", path: '', element: <Navigate to="/support/notice" /> }
        ]
    },
    { breadcrumb: "이용약관", name: "이용약관", navigation: false, path: "/tos", element: <Tos /> },
    { breadcrumb: "개인정보처리방침", name: "개인정보처리방침", navigation: false, path: "/privacy", element: <Privacy /> },
    { path: "*", element: <NotFound /> }
];

if (process.env.NODE_ENV === "production") {
    sm = [
        { breadcrumb: "홈", path: "/", element: <Home /> },
        { breadcrumb: "소개", name: "소개", navigation: true, path: "/about", element: <About />},
        { breadcrumb: "다운로드", name: "다운로드", navigation: true, path: "/download", element: <Download /> },
        {
            breadcrumb: "고객지원", name: "고객지원", navigation: true, path: "support",
            children: [
                { breadcrumb: "공지사항", name: "공지사항", navigation: true, path: "notice", element: <Notice /> },
                { breadcrumb: "FAQ", name: "FAQ", navigation: true, path: "faq", element: <Faq /> },
                { breadcrumb: "1:1 문의", name: "1:1 문의", navigation: true, path: "qna", element: <Qna /> },
                { breadcrumb: "고객지원", path: '', element: <Navigate to="/support/notice" /> }
            ]
        },
        { breadcrumb: "이용약관", name: "이용약관", navigation: false, path: "/tos", element: <Tos /> },
        { breadcrumb: "개인정보처리방침", name: "개인정보처리방침", navigation: false, path: "/privacy", element: <Privacy /> },
        { path: "*", element: <NotFound /> }
    ]
}

export const sitemap = sm;